import { render, staticRenderFns } from "./ExpenseCategory.vue?vue&type=template&id=1ae62049&scoped=true&"
import script from "./ExpenseCategory.vue?vue&type=script&lang=js&"
export * from "./ExpenseCategory.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseCategory.vue?vue&type=style&index=0&id=1ae62049&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae62049",
  null
  
)

export default component.exports